import { app } from '../firebaseConfig';

export const APP_CHECK_TIMEOUT_MS = 5000;
let clientPromise: Promise<any> | null = null;
let tokenPromise: Promise<string | undefined> | null = null;

/** App Check is optional client evidence; the server owns its enforcement mode. */
export async function getBrowserVerificationToken(): Promise<string | undefined> {
  const siteKey = process.env.REACT_APP_APP_CHECK_SITE_KEY;
  if (!siteKey || typeof window === 'undefined') return undefined;
  if (tokenPromise) return tokenPromise;
  tokenPromise = (async () => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      if (!clientPromise) {
        clientPromise = import('firebase/app-check').then(({ initializeAppCheck, ReCaptchaV3Provider }) =>
          initializeAppCheck(app, { provider: new ReCaptchaV3Provider(siteKey), isTokenAutoRefreshEnabled: true }),
        ).catch(() => null);
      }
      const lookup = (async () => {
        const client = await clientPromise;
        if (!client) return undefined;
        const { getToken } = await import('firebase/app-check');
        const token = (await getToken(client, false)).token;
        return typeof token === 'string' && token.length <= 8192 && /^[A-Za-z0-9._-]+$/.test(token) ? token : undefined;
      })();
      return await Promise.race([
        lookup,
        new Promise<undefined>(resolve => { timer = setTimeout(() => resolve(undefined), APP_CHECK_TIMEOUT_MS); }),
      ]);
    } catch (_) {
      return undefined;
    } finally {
      if (timer !== undefined) clearTimeout(timer);
      tokenPromise = null;
    }
  })();
  return tokenPromise;
}

export async function getBrowserVerificationHeaders(): Promise<Record<string, string>> {
  const token = await getBrowserVerificationToken();
  return token ? { 'X-Firebase-AppCheck': token } : {};
}
